// Types
import { Icon as IconType } from '../../../types/icon';
import { Measurements } from '../../../types/measurements';

// Utils
import { getMeasurementBySize } from '../../../utils/icon';

// Component
import Icon from '../Icon/Icon';

const IconInputOne = (props: IconType) => {
  const {
    size,
    inverse,
    onClick,
    width,
    height,
    iconClassName,
  } = props;

  const defaultMeasurements: Measurements = {
    height: 9,
    width: 16,
  }

  const measurements = size ? getMeasurementBySize(size) : defaultMeasurements;

  return (
    <Icon inverse={inverse} onClick={onClick} className={iconClassName} classNameIconType="c-icon-input-one">
      <svg
        className="c-icon-input-one fill-current"
        width={width || measurements.width}
        height={height || measurements.height}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M16 1.52381V14.5524C15.9804 14.9432 15.8113 15.3115 15.5276 15.581C15.2439 15.8504 14.8675 16.0005 14.4762 16H5.46286C5.06523 16.0001 4.68331 15.8448 4.39861 15.5672C4.11391 15.2897 3.94899 14.9118 3.93905 14.5143V13.1352C3.93905 12.9332 4.01932 12.7394 4.1622 12.5965C4.30509 12.4536 4.49888 12.3733 4.70095 12.3733C4.90302 12.3733 5.09682 12.4536 5.2397 12.5965C5.38259 12.7394 5.46286 12.9332 5.46286 13.1352V14.5143L14.4762 14.4762V1.52381H5.46286V2.86476C5.46286 3.06683 5.38259 3.26062 5.2397 3.40351C5.09682 3.54639 4.90302 3.62667 4.70095 3.62667C4.49888 3.62667 4.30509 3.54639 4.1622 3.40351C4.01932 3.26062 3.93905 3.06683 3.93905 2.86476V1.52381C3.93905 1.11967 4.09959 0.732083 4.38536 0.446313C4.67113 0.160544 5.05872 0 5.46286 0H14.4762C14.8803 0 15.2679 0.160544 15.5537 0.446313C15.8395 0.732083 16 1.11967 16 1.52381ZM5.55429 10.0876C5.4292 10.2411 5.36879 10.4373 5.38584 10.6345C5.40289 10.8318 5.49606 11.0147 5.64563 11.1444C5.79519 11.2742 5.98939 11.3406 6.18709 11.3297C6.38479 11.3187 6.57046 11.2312 6.70476 11.0857L8.95238 8.50286C9.07453 8.36382 9.14189 8.18507 9.14189 8C9.14189 7.81493 9.07453 7.63618 8.95238 7.49714L6.70476 4.91429C6.57046 4.76879 6.38479 4.6813 6.18709 4.67034C5.98939 4.65937 5.79519 4.72581 5.64563 4.85556C5.49606 4.98531 5.40289 5.1682 5.38584 5.36546C5.36879 5.56273 5.4292 5.75889 5.55429 5.91238L6.70476 7.23809H0.761905C0.559835 7.23809 0.366042 7.31837 0.223157 7.46125C0.0802718 7.60414 0 7.79793 0 8C0 8.20207 0.0802718 8.39586 0.223157 8.53875C0.366042 8.68163 0.559835 8.7619 0.761905 8.7619H6.70476L5.55429 10.0876Z" />
      </svg>
    </Icon>
  );
};

export default IconInputOne;
